import { useTranslation } from "react-i18next";
import "../../../styles/UserAuthPage.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { supabase } from "../../../lib/supabase";
import { signInUser } from "../../../services/authService";
import Header from "./Header";
import FormInputFields from "./FormInputFields";

function AdminForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // Handle form field changes
  // It looks at the input field being typed into and grabs:
  //   name  → which field it is (e.g "email" or "password")
  //   value → what the user just typed
  const onChange = (e) => {
    const { name, value } = e.target;
    // Keeps everything the same, but updates only the field the user is typing in
    setForm((f) => ({ ...f, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    setErrorMessage("");
    setIsLoading(true);

    try {
      // Login normally
      const { data, error } = await signInUser(form);

      if (error) {
        setErrorMessage(error?.message);
        return;
      }

      // Get user profile
      const { data: profile } = await supabase
        .from("users")
        .select("*")
        .eq("id", data.user.id)
        .single();

      // Check if the user is an admin
      if (profile.role !== "admin") {
        setErrorMessage("Access denied");
        // Logout isommediately
        await supabase.auth.signOut();

        return;
      }

      // Redirect to dashboard
      navigate("/dashboard", { replace: true });
    } catch (error) {
      setErrorMessage("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="adminAuth__formWrap">
      <div className="adminAuth__formCard">
        {/* Header */}
        <Header />

        {/* Error message when login fails */}
        {errorMessage && (
          <div className="adminAuth__error" role="alert">
            {errorMessage}
          </div>
        )}

        {/* Form */}
        <form onSubmit={onSubmit} className="adminAuth__form">
          {/* Input fields */}
          <FormInputFields form={form} onChange={onChange} />

          {/* Login Button*/}
          <button type="submit" className="adminAuth__submit" disabled={isLoading}>
            {isLoading ? "Signing in…" : t("adminLogin.submit")}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminForm;
